import React from "react";

class Heliodora extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="painting-item" id="heliodora">
                <div className="painting-item-left">
                    <div className="painting-container">
                        <img src='/alphabet-2013/heliodora.webp' className="painting-image"></img>
                        <div className="painting-title">
                            Héliodora
                            <br/>
                            Janvier 2013
                        </div>
                    </div>
                </div>
                <div className="painting-item-right">
                    <h3 className="painting-text-subtitle">Héliodora</h3>
                    <p className="painting-item-text">
                        C'est un chat de Leonor Fini.
                    </p>
                </div>
            </div>
        );
    }

}

export {Heliodora};
